import React, { useState, useRef } from "react";
import HeroUdin from "../Components/HeroUdin";
import Footer from "../Components/Footer";
import CamingSon from "./ComingSon";
// import Navbar from "../Components/Navbar";

const LandingPageUdin: React.FC = () => {
  const [currentPage, setCurrentPage] = useState("Beranda");
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [showComingSon, setShowComingSon] = useState(false);

  const berandaRef = useRef<HTMLDivElement>(null);
  const MerchantBisnisRef = useRef<HTMLDivElement>(null);

  const handleMenuClick = (page: string) => {
    if (page === "Merchant Bisnis") {
      setCurrentPage(page);
      window.scrollTo({
        top: 0,
        behavior: "smooth",
      });
      return;
    }

    setCurrentPage(page);
    setShowComingSon(page === "Download");

    setIsMenuOpen(false);
  };

  return (
    <section className="font-signika max-w-[1440px] mx-auto ">
      {/* <div className="fixed top-0 left-0 w-full z-40 bg-white">
        <Navbar currentPage={currentPage} isMenuOpen={isMenuOpen} handleMenuClick={handleMenuClick} setIsMenuOpen={setIsMenuOpen} />
      </div> */}

      <section className="pt-[80px] grid grid-cols-1">
        {showComingSon ? (
          <CamingSon />
        ) : currentPage === "Merchant Bisnis" ? (
          <div ref={MerchantBisnisRef}>asd</div>
        ) : (
          <>
            <div ref={berandaRef}>
              <HeroUdin handleMenuClick={handleMenuClick} />
            </div>

            <Footer handleMenuClick={handleMenuClick} />
          </>
        )}
      </section>
    </section>
  );
};

export default LandingPageUdin;
